import { MAX_TICKETS } from 'app/shared/utils/events';

import { DEFAULT_TICKETS } from './constants';

interface EventForCalculateMaxTickets {
  remainingSpaces: number;
  maxTicketsPerAttendee: number;
}

interface EventAttendeeForCalculateMaxTickets {
  source?: string;
  tickets: {
    id: number;
  }[];
}

/** Calculate the max number of tickets the current user can buy */
export function calcMaxTicketsCanPurchase(
  event: EventForCalculateMaxTickets | null,
  eventAttendee?: EventAttendeeForCalculateMaxTickets | null
): number {
  if (!event) {
    return 0;
  }

  const numTicketsAlreadyPurchased = eventAttendee?.tickets.length || 0;
  const isCompetition = eventAttendee?.source == 'competition';

  const max = Math.min(
    isCompetition ? DEFAULT_TICKETS : MAX_TICKETS,
    event.remainingSpaces,
    event.maxTicketsPerAttendee - numTicketsAlreadyPurchased
  );

  return Math.max(max, DEFAULT_TICKETS);
}
